/* sb-dc-tplrot.js - put the rotate() angle from the source SVG back on the
   text layers. 2026-09-12 (v8).

   The app's SVG-to-layer converter drops the angle, so vertical text is drawn
   lying flat and overlapping until this puts it back.

   FIVE FAILED ATTEMPTS AT MAKING IT FASTER - all measured, all reverted:
     v1  re-apply every 0.7s            -> the text visibly jittered
     v2  apply once when stable         -> a later rebuild undid it
     v5  apply immediately, then settle -> ENDED at rotation 0
     v6  settle window 3.2s -> 1.2s     -> rounds 5, applied 10, ENDED at 0
     v7  fast settle after a 9s cap     -> applied 8, ENDED at 0
   The lesson from v7 is the important one: when the gate does not open, the
   fallback has to be the SLOW setting. Falling back to the fast one is just v6
   again, and being early means being wrong permanently.

   v8 keeps the old 3.3s-of-quiet rule as the default and only uses the short
   0.6s rule when the earlier steps SAY they are finished - sb-dc-tplshrink.js
   and sb-dc-tplmerge.js both report `settled`. Nothing is guessed from a
   clock.

   MEASURED THE SAME DAY, which is why the gate exists at all: hooking setDoc,
   loadTemplate, reset, undo and redo for 30s caught exactly one call -
   loadTemplate at 352ms, from sb-dc-tplfix.js. The app does NOT rebuild the
   board over and over. What kept the layer coordinates moving was our own
   scripts on the same page, each waiting for a quiet that the others kept
   breaking.

   Diagnostics: window.__dcTplRot() - `gated` and `gateMs` say whether the
   short rule was used and when it became available. */
(function () {
  'use strict';

  var TICK = 300;
  var SETTLE_GATED = 2;      // 0.6s once the earlier steps say they are done
  var SETTLE_BLIND = 11;     // 3.3s otherwise - the v4 behaviour, known good
  var WINDOW_MS = 40000;

  var info = { pairs: 0, applied: 0, rounds: 0, gated: false, gateMs: 0, why: '' };
  window.__dcTplRot = function () { return info; };

  function q(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  var tpl = q('tpl');
  if (!tpl) { info.why = 'no tpl'; return; }

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toUpperCase(); }

  function angleOf(el) {
    var node = el, hops = 0;
    while (node && hops < 4) {
      var t = node.getAttribute && node.getAttribute('transform');
      if (t) {
        var m = /rotate\(\s*(-?[\d.]+)/.exec(t);
        if (m) {
          var a = parseFloat(m[1]);
          if (isFinite(a) && Math.abs(a) > 0.5) return a;
        }
      }
      node = node.parentNode;
      hops++;
    }
    return 0;
  }

  var ROT = [];

  function load() {
    var sb = window.__dcSupabase;
    if (!sb || !sb.url || !sb.anonKey) { info.why = 'no supabase handle'; return; }
    fetch(sb.url + '/rest/v1/dc_templates?select=file_url,content_type&id=eq.' + encodeURIComponent(tpl), {
      headers: { apikey: sb.anonKey, Authorization: 'Bearer ' + sb.anonKey }
    })
      .then(function (r) { return r.json(); })
      .then(function (rows) {
        if (!Array.isArray(rows) || !rows.length || !rows[0].file_url) throw new Error('no row');
        if (!/svg/i.test(rows[0].content_type || rows[0].file_url)) throw new Error('not svg');
        return fetch(rows[0].file_url).then(function (r) { return r.text(); });
      })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
        var texts = doc.getElementsByTagName('text');
        for (var i = 0; i < texts.length; i++) {
          var a = angleOf(texts[i]);
          if (!a) continue;
          var s = norm(texts[i].textContent);
          if (s) ROT.push({ text: s, angle: a });
        }
        info.pairs = ROT.length;
      })
      .catch(function (e) { info.why = String(e && e.message || e).slice(0, 60); });
  }

  function angleFor(l) {
    if (!l || l.type !== 'text') return 0;
    var s = norm(l.text || l.name);
    for (var i = 0; i < ROT.length; i++) if (ROT[i].text === s) return ROT[i].angle;
    return 0;
  }

  function pending(api) {
    var sides = ['front', 'back'], n = 0;
    sides.forEach(function (side) {
      var sd = api[side];
      if (!sd || !Array.isArray(sd.layers)) return;
      sd.layers.forEach(function (l) {
        if (l.type === 'text' && !+l.rotation && angleFor(l)) n++;
      });
    });
    return n;
  }

  /* Have the earlier steps said they are done? A module that is not loaded
     counts as done. sb-dc-flagfit.js is deliberately not consulted: it is slow
     to decide and, when it skips, it never touches text. */
  function earlierStepsDone() {
    try {
      var s = window.__dcTplShrink && window.__dcTplShrink();
      if (s && !s.settled) return false;
      var m = window.__dcTplMerge && window.__dcTplMerge();
      if (m && !m.settled) return false;
    } catch (e) {}
    return true;
  }

  function apply(api, side) {
    if(window.SBDC914?.host.handled(api[side])) return;
    var sd = api[side];
    if (!sd || !Array.isArray(sd.layers)) return;
    sd.layers.forEach(function (l) {
      if (l.type !== 'text' || +l.rotation) return;
      var a = angleFor(l);
      if (!a) return;
      var p = { rotation: a };
      if (Math.abs(Math.abs(a) - 90) < 1) {
        var cx = (+l.xIn || 0) + (+l.widthIn || 0) / 2;
        var cy = (+l.yIn || 0) + (+l.heightIn || 0) / 2;
        var w = (+l.heightIn || 0), h = (+l.widthIn || 0);
        p.widthIn = w; p.heightIn = h;
        p.xIn = cx - w / 2; p.yIn = cy - h / 2;
      }
      api.updateLayer(l.id, p);
      info.applied++;
    });
  }

  function sigOf(api) {
    var L = (api.front && api.front.layers) || [];
    if (!L.length) return '';
    var s = api.spec.widthIn + 'x' + api.spec.heightIn;
    for (var i = 0; i < L.length; i++) {
      var l = L[i];
      s += '|' + l.id + ',' + (+l.xIn).toFixed(2) + ',' + (+l.yIn).toFixed(2)
         + ',' + (+l.widthIn).toFixed(2) + ',' + (+l.heightIn).toFixed(2) + ',' + (+l.rotation || 0);
    }
    return s;
  }

  load();

  var t0 = Date.now(), sig = '', same = 0;
  var t = setInterval(function () {
    var age = Date.now() - t0;
    if (age > WINDOW_MS) { clearInterval(t); return; }
    if (!ROT.length) return;
    var api = window.__dcApi;
    if (!api || !api.spec || typeof api.updateLayer !== 'function') return;
    if (!pending(api)) { same = 0; sig = sigOf(api); return; }

    var gated = earlierStepsDone();
    if (gated && !info.gated) { info.gated = true; info.gateMs = age; }
    var need = gated ? SETTLE_GATED : SETTLE_BLIND;

    var s = sigOf(api);
    if (s !== sig) { sig = s; same = 0; return; }
    if (++same < need) return;
    same = 0;
    info.rounds++;
    try {
      apply(api, 'front');
      if (api.back && api.back.layers && api.back.layers.length) apply(api, 'back');
    } catch (e) { info.why = 'error: ' + (e && e.message); }
    sig = '';
  }, TICK);
})();
